import React, { useState } from "react";

const DirectoryUpload = () => {
  const [files, setFiles] = useState([]);
  let uploadedFileNames = []; // Initialize the variable

  const handleDirectoryUpload = (event) => {
    const filesArray = Array.from(event.target.files);
    setFiles(filesArray); // Update 'files' with the uploaded files
    // Save the file names to uploadedFileNames
    uploadedFileNames = filesArray.map(file => file.name);
    console.log(uploadedFileNames); // Now uploadedFileNames contains the file names
  };

  const handleUpload = async () => {
    const formData = new FormData();
    files.forEach((file) => {
      formData.append('files', file, file.webkitRelativePath);
    });

    try {
      const response = await fetch('YOUR_UPLOAD_URL', {
        method: 'POST',
        body: formData,
      });

      if (response.ok) {
        alert('Files uploaded successfully');
      } else {
        alert('Failed to upload files');
      }
    } catch (error) {
      console.error('Error uploading files:', error);
      alert('An error occurred while uploading the files');
    }
  };

  return (
    <div>
      <input 
        type="file" 
        webkitdirectory="true" 
        mozdirectory="true" 
        msdirectory="true" 
        odirectory="true" 
        directory="true" 
        multiple 
        onChange={handleDirectoryUpload} 
      />
      <button onClick={handleUpload}>Upload Files</button>
      <ul>
        {files.map((file, index) => (
          <li key={index}>{file.webkitRelativePath}</li>
        ))}
      </ul>
    </div>
  );
};

export default DirectoryUpload;
